export default __webpack_public_path__ + "static/media/destination_pin.d2068fbc.png";